import { render, staticRenderFns } from "./CvWorkXp.vue?vue&type=template&id=1585c306&scoped=true"
import script from "./CvWorkXp.vue?vue&type=script&lang=js"
export * from "./CvWorkXp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585c306",
  null
  
)

export default component.exports